export enum DisputeReason{
    Other = 21
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/dispute-reason.enum.ts